import { render, staticRenderFns } from "./complaint_histoty.vue?vue&type=template&id=486e3a38"
import script from "./complaint_histoty.vue?vue&type=script&lang=js"
export * from "./complaint_histoty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports